import { LEVEL_RANK, type Level, type Module } from '@plataforma/shared';
import type { Me } from './types';

/** Misma regla que el servidor (auth/permissions.ts). */
export function can(me: Me | null, module: Module, level: Level, campusId: string | null | 'any' = 'any'): boolean {
  if (!me) return false;
  if (me.account.isSuperAdmin) return true;
  const need = LEVEL_RANK[level];
  return me.roles.some((r) => {
    if (r.module !== module || LEVEL_RANK[r.level] < need) return false;
    if (campusId === 'any') return true;
    if (campusId === null) return level === 'viewer' ? true : r.campusId === null;
    return r.campusId === null || r.campusId === campusId;
  });
}

/** Campus en los que tiene cierto nivel en un módulo (null = todos). */
export function campusesFor(me: Me | null, module: Module, level: Level = 'viewer'): string[] | null {
  if (!me) return [];
  if (me.account.isSuperAdmin) return null;
  const grants = me.roles.filter((r) => r.module === module && LEVEL_RANK[r.level] >= LEVEL_RANK[level]);
  if (grants.some((g) => g.campusId === null)) return null;
  return [...new Set(grants.map((g) => g.campusId as string))];
}
